// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3J-bV","vLegacy":"SelectSecondary_vLegacy__1oN27","error":"SelectSecondary_error__2kXyl","disabled":"SelectSecondary_disabled___mh0E"};